exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * @license\n * Copyright Akveo. All Rights Reserved.\n * Licensed under the MIT License. See License.txt in the project root for license information.\n */\n:host /deep/ {\n  display: block; }\n  :host /deep/ .menu-items,\n  :host /deep/ .menu-item > .menu-items {\n    list-style-type: none;\n    overflow: hidden; }\n    :host /deep/ .menu-items.collapsed,\n    :host /deep/ .menu-item > .menu-items.collapsed {\n      max-height: 0;\n      transition: max-height 0.15s ease-out; }\n    :host /deep/ .menu-items.expanded,\n    :host /deep/ .menu-item > .menu-items.expanded {\n      max-height: 300px;\n      transition: max-height 0.3s ease-in; }\n  :host /deep/ .menu-item a {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    color: inherit;\n    text-decoration: none;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center; }\n    :host /deep/ .menu-item a .menu-title {\n      -webkit-box-flex: 1;\n          -ms-flex: 1;\n              flex: 1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/dev/FitRadioAdmin2/src/app/@nebular/theme/components/menu/menu.component.scss
// module id = ../../../../../src/app/@nebular/theme/components/menu/menu.component.scss
// module chunks = main